import _asyncToGenerator from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/regenerator/index.js";

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
// tslint:disable-next-line: no-imports-from-dist
import * as tfOps from '@tensorflow/tfjs-core/dist/ops/ops_for_converter';
import { getParamValue } from './utils';

function nmsParams(node, tensorMap, context) {
  var boxes = getParamValue('boxes', node, tensorMap, context);
  var scores = getParamValue('scores', node, tensorMap, context);
  var maxOutputSize = getParamValue('maxOutputSize', node, tensorMap, context);
  var iouThreshold = getParamValue('iouThreshold', node, tensorMap, context);
  var scoreThreshold = getParamValue('scoreThreshold', node, tensorMap, context);
  var softNmsSigma = getParamValue('softNmsSigma', node, tensorMap, context);
  return {
    boxes: boxes,
    scores: scores,
    maxOutputSize: maxOutputSize,
    iouThreshold: iouThreshold,
    scoreThreshold: scoreThreshold,
    softNmsSigma: softNmsSigma
  };
}

export var executeOp = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node, tensorMap, context) {
    var _nmsParams, boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma, result, _nmsParams2, _boxes, _scores, _maxOutputSize, _iouThreshold, _scoreThreshold, padToMaxOutputSize, _result, _nmsParams3, _boxes2, _scores2, _maxOutputSize2, _iouThreshold2, _scoreThreshold2, condition, _result2;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = node.op;
            _context.next = _context.t0 === 'NonMaxSuppressionV5' ? 3 : _context.t0 === 'NonMaxSuppressionV4' ? 8 : _context.t0 === 'NonMaxSuppressionV3' ? 14 : _context.t0 === 'NonMaxSuppressionV2' ? 14 : _context.t0 === 'Where' ? 19 : _context.t0 === 'ListDiff' ? 26 : 27;
            break;

          case 3:
            _nmsParams = nmsParams(node, tensorMap, context), boxes = _nmsParams.boxes, scores = _nmsParams.scores, maxOutputSize = _nmsParams.maxOutputSize, iouThreshold = _nmsParams.iouThreshold, scoreThreshold = _nmsParams.scoreThreshold, softNmsSigma = _nmsParams.softNmsSigma;
            _context.next = 6;
            return tfOps.image.nonMaxSuppressionWithScoreAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);

          case 6:
            result = _context.sent;
            return _context.abrupt("return", [result.selectedIndices, result.selectedScores]);

          case 8:
            _nmsParams2 = nmsParams(node, tensorMap, context), _boxes = _nmsParams2.boxes, _scores = _nmsParams2.scores, _maxOutputSize = _nmsParams2.maxOutputSize, _iouThreshold = _nmsParams2.iouThreshold, _scoreThreshold = _nmsParams2.scoreThreshold;
            padToMaxOutputSize = getParamValue('padToMaxOutputSize', node, tensorMap, context);
            _context.next = 12;
            return tfOps.image.nonMaxSuppressionPaddedAsync(_boxes, _scores, _maxOutputSize, _iouThreshold, _scoreThreshold, padToMaxOutputSize);

          case 12:
            _result = _context.sent;
            return _context.abrupt("return", [_result.selectedIndices, _result.validOutputs]);

          case 14:
            _nmsParams3 = nmsParams(node, tensorMap, context), _boxes2 = _nmsParams3.boxes, _scores2 = _nmsParams3.scores, _maxOutputSize2 = _nmsParams3.maxOutputSize, _iouThreshold2 = _nmsParams3.iouThreshold, _scoreThreshold2 = _nmsParams3.scoreThreshold;
            _context.next = 17;
            return tfOps.image.nonMaxSuppressionAsync(_boxes2, _scores2, _maxOutputSize2, _iouThreshold2, _scoreThreshold2);

          case 17:
            _context.t1 = _context.sent;
            return _context.abrupt("return", [_context.t1]);

          case 19:
            condition = tfOps.cast(getParamValue('condition', node, tensorMap, context), 'bool');
            _context.next = 22;
            return tfOps.whereAsync(condition);

          case 22:
            _context.t2 = _context.sent;
            _result2 = [_context.t2];
            condition.dispose();
            return _context.abrupt("return", _result2);

          case 26:
            return _context.abrupt("return", tfOps.setdiff1dAsync(getParamValue('x', node, tensorMap, context), getParamValue('y', node, tensorMap, context)));

          case 27:
            throw TypeError("Node type ".concat(node.op, " is not implemented"));

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function executeOp(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var CATEGORY = 'dynamic';